import { createRouter, createWebHistory } from 'vue-router'
import Billing from '@/views/Billing.vue'
import VirtualReality from '@/views/VirtualReality.vue'
import Profile from '@/views/Profile.vue'
import Rtl from '@/views/Rtl.vue'
import SignIn from '@/views/SignIn.vue'
import SignUp from '@/views/SignUp.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/SignIn.vue')
  },
  {
    path: '/',
    name: '/',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/Layout/Layout.vue'),
    children: [
      {
        path: '',
        name: 'Dashboard',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/views/Usuarios.vue'
          )
      },
      {
        path: '/usuarios',
        name: 'Usuarios',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/views/Usuarios.vue'
          ),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/categorias',
        name: 'Categorias',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/views/Categorias.vue'
          ),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/multimedia',
        name: 'TipoMultimedia',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/views/TipoMultimedia.vue'
          ),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/billing',
        name: 'Billing',
        component: Billing,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/virtual-reality',
        name: 'Virtual Reality',
        component: VirtualReality,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/rtl-page',
        name: 'Rtl',
        component: Rtl,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/sign-in',
        name: 'Sign In',
        component: SignIn,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/sign-up',
        name: 'Sign Up',
        component: SignUp,
        meta: {
          requiresAuth: true
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: 'active'
})

router.beforeEach(async (to, from, next) => {
  if (to.meta?.requiresAuth && !localStorage.getItem('login') && !localStorage.getItem('token') && !localStorage.getItem('refreshToken')) {
    next({
      path: '/login',
      replace: true
    })
  } else if (to.name === 'Login' && localStorage.getItem('login') && localStorage.getItem('token') && localStorage.getItem('refreshToken')) {
    next({
      path: '/',
      replace: true
    })
  } else {
    next()
  }
})

export default router
